@if (showAtlasIcon) {
  <img
    class="legal-footer-icon"
    src="assets/images/logo/icon.svg"
    alt="Kommunal-Atlas" />
}
@for (link of links; track link.label) {
  <a class="legal-footer-link" [href]="link.url" target="_blank">{{
    link.label
  }}</a>
}
